import { debounce } from "lodash";
import { scroller } from "react-scroll";

export const hashString = (str) => {
  var hash = 0,
    i,
    chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return String(hash);
};

export const trimStr = (str) => {
  return str.trim().replace(/\s+/g, ' ');
};

export const normalizeString = (str) => {
  return str.toLowerCase().replace(/\s+/g, '');
};

export const tryParseJson = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return [];
  }
};

export const generateRowId = (section, content, suffix = '') => {
  if (typeof content === 'string') {
    return normalizeString(
      (section || '') +
      content.replace(/[^a-zA-Z0-9]/g, '').substring(0, 250) + (suffix || '')
    );
  }

  if (typeof content === 'object') {
    let text = '';

    for (const key in content) {
      if (key === 'selection') {
        continue;
      }

      text += `${key}:${content[key]}`;
    }

    return normalizeString((section || '') + text + (suffix || ''));
  }
};

let targetToScrollTo = null;
const debouncedScrollTo = debounce(() => {
  scroller.scrollTo(targetToScrollTo.id, {
    smooth: true,
    duration: 1000,
    offset: window.innerHeight / -2,
    ...targetToScrollTo.options
  });
  targetToScrollTo = null;
}, 300, { leading: false, trailing: true });

export const priorityScrollTo = (id, priority, options) => {
  if (!targetToScrollTo || targetToScrollTo.priority > priority) {
    targetToScrollTo = { id, priority, options };
  }

  debouncedScrollTo();
}